import { useQueryClient } from '@tanstack/react-query';
import SharedToolbar from '../../../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../../../shared/shared-grid-state-icon-button-latest';
import { UserKeys } from '../../../../../api/users-api';
import CreateButton from '../../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../../shared/buttons/shared-icon-button';

interface ManageSlackChannelsGridToolbarProps {
  openCreateDialog: () => void;
}

export default function ManageSlackChannelsGridToolbar({
  openCreateDialog,
}: Readonly<ManageSlackChannelsGridToolbarProps>) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton label="Create Collection" onClick={openCreateDialog} />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.SlackChannels],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="slackChannelsGridStates"
            module="administration"
            section="slack"
          />
        </>
      }
    />
  );
}
